import { render, staticRenderFns } from "./list-customer.vue?vue&type=template&id=ea9b496e&scoped=true"
import script from "./list-customer.vue?vue&type=script&lang=js"
export * from "./list-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9b496e",
  null
  
)

export default component.exports